export enum EFirestoreCollections {
  MERCHANT_THEME = 'merchant-theme',
}
